/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import BaseCom from "./BaseCom"
import Breadcrumb from "./Breadcrumb";
import LoadingAlert from "./LoadingAlert";
import withParams from "./WithParams";
import { qreq } from "../shared/qrequest";
import { SidebarGlobal } from "./_SidebarGlobal";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as fa from '@fortawesome/free-solid-svg-icons';
import MessageDialog from "./MessageDialog";
import Card from "./Card";
import FormInput from "./FormInput";
import Icon from "./Icon";
import L from "./Lang";
import AppActions from "./AppActions";

class GroupView extends BaseCom {

    constructor(props) {
        super(props);
        this.state = {
            user: null,
            item: {
                _contacts: [],
            },
            contactList: [],
            saving: false,
            loading: true
        };

        this.submit = this.submit.bind(this);
    }

    componentDidMount() {
        if (this.props.params.id) {
            qreq.get('/api/group/get/' + this.props.params.id, j => {
                if (j.errorCode)
                    this.alert(j.errorMessage);
                else {
                    this.processItem(j.item);
                    this.setState({ item: j.item });
                }
                this.setState({ loading: false });
            }, e => {
                this.goBack();
            });
        }
        else
            this.setState({ loading: false });

        qreq.post('/api/contact/list', {}, j => {
            if (j.list)
                this.setState({ contactList: j.list });
        });

        SidebarGlobal.setSubNav(<><button type="button" className="btn btn-success" onClick={() => document.getElementById('c-submit').click()}><FontAwesomeIcon icon={fa.faSave} /> <L>Save</L></button></>);

    }

    componentWillUnmount() {
        SidebarGlobal.clearSubNav();
    }

    processItem(item) {
        item._contacts = [];
        item.links.forEach(i => {
            if (i.linkType === 'Contact') {
                item._contacts.push(i.itemID);
            }
        });
    }

    submit(e) {
        e.preventDefault();
        this.setState({ saving: true });

        var item = { ...this.state.item };

        item.links = [];

        item._contacts.forEach(i => {
            var c = this.state.contactList.find(a => a.id === i);
            if (c) {
                item.links.push({
                    name: c.firstName + ' ' + c.lastName,
                    linkType: 'Contact',
                    itemID: c.id
                });
            }
        });

        qreq.post('/api/group/save', item, (j) => {
            if (j.errorCode !== 0)
                alert(j.errorMessage);
            else
                this.goBack();

            this.setState({ saving: false });
        }, this.unkownErrorCallback);
    }

    render() {
        if (this.state.loading)
            return (<div className="container-fluid"><h1><L>Edit Group</L></h1><LoadingAlert /></div>);

        SidebarGlobal.setSubNav(<><button type="button" className="btn btn-success" onClick={() => document.getElementById('c-submit').click()}><FontAwesomeIcon icon={fa.faSave} /> <L>Save</L></button></>);

        if (!this.state.item)
            return null;
        return <div className="container-fluid">
            <form onSubmit={this.submit}>
                <h1><L>Edit Group</L></h1>
                <Breadcrumb path={[['Groups', '/group/list'], ['Edit']]} />
                <AppActions>
                    <button type="submit" className="btn btn-success btn-lg"><FontAwesomeIcon icon={fa.faSave} /> <L>Save</L></button>
                </AppActions>
                <Card title="Group Info">
                    <FormInput model={this.state.item} name="name" label="Group Name" type="text" required />
                    <FormInput model={this.state.item} name="groupType" label="Group Type" type="select" options={[
                        { id: 'IVR', name: 'IVR ' },
                        { id: 'ORGANIZATION', name: 'Organization ' }
                    ]} required />
                </Card>
                <Card title="Members">
                    <ul className="list-group">
                        {this.state.contactList.map(i => <li key={i.id} role="button" className={'list-group-item' + (this.state.item._contacts.indexOf(i.id) >= 0 ? ' list-group-item-success' : '')} onClick={() => {
                            var list = [...this.state.item._contacts];
                            var idx = list.indexOf(i.id);
                            if (idx >= 0)
                                list.splice(idx, 1);
                            else
                                list.push(i.id);
                            console.log(list);
                            this.setState({ item: { ...this.state.item, _contacts: list } });
                        }}>
                            {this.state.item._contacts.indexOf(i.id) >= 0 ? <Icon icon="faCheck" /> : <Icon icon="faSquare" outline />}
                            {i.name} ({i.email})
                        </li>)}
                    </ul>
                </Card>
                {this.state.saving ? (<MessageDialog title="Saving" message="Processing..." />) : (<>
                    <div className="d-none">
                        <button id="c-submit" type="submit" className="btn btn-success d-inline-block"><L>Save</L></button>
                        <button type="button" className="btn btn-secondary d-inline-block ms-1" onClick={this.goBack}><L>Cancel and Go Back</L></button>
                    </div></>)}
            </form>
        </div>;
    }
}

export default withParams(GroupView);